<template>
  <div>
    <upi-filter v-if="getterPopupName === 'UpiTxnFilters'"
          @updateFilters="updateFilters" />
    <upi-export v-else-if="getterPopupName === 'UpiTxnExports'"
          :exportOptions="paginate" :exportRecords="exportRecords" />
    <upi-details v-else-if="getterPopupName === 'UpiTxnDetails'"
          :txnDetails="popupDetails" />

    <div class="table-title">
      <div class="subject">
        <p>UPI Statement</p>

        <upi-webhooks v-if="list.length && webhooksAllowed"
              :paginate="paginate" @resendWebhooks="bulkResendWebhooks" />
      </div>

      <div class="filters">
        <div class="options">
          <button @click="openPopup('UpiTxnExports')">
            Export
            <i class="fa fa-share" />
          </button>
          <button :class="{'filters-applied': filtersApplied}"
                  class="dark-btn"
                  @click="openPopup('UpiTxnFilters')">
            Filter
            <i class="fa fa-filter" />
          </button>
        </div>
      </div>
    </div>

    <div class="table-head" v-if="isDesktop()">
      <p>ID</p>
      <p class="d-l">Time</p>
      <p>Type</p>
      <p>Payment Mode</p>
      <p>Transaction Amount</p>
      <p>Fees &amp; GST</p>
      <p>Settlement Amount</p>
      <p>Credit/Debit</p>
      <p>Status</p>
    </div>

    <div class="table-body">
      <div class="table-row" v-for="(txn, index) in list" :key="index"
            @click="showDetails(txn)">
        <p class="mt-grey-text">
          <b v-if="!isDesktop()">ID:</b>
          {{txn.id}}
        </p>
        <p class="mt-right mt-grey-text d-l">{{txn.created_at}}</p>
        <p>
          <b v-if="!isDesktop()">Type:</b>
          {{txn.txn_type}}
        </p>
        <p class="mt-right">
          <b v-if="!isDesktop()">Pymt Mode:</b>
          {{txn.payment_type}}
        </p>
        <p>
          <b v-if="!isDesktop()">Txn Amount:</b>
          {{amountFormat(txn.amount)}}
        </p>
        <p class="mt-right">
          <b v-if="!isDesktop()">Fees &amp; GST:</b>
          {{amountFormat(txn.charges_gst)}}
        </p>
        <p>
          <b v-if="!isDesktop()">Settlement Amt:</b>
          {{amountFormat(txn.settled_amount)}}
        </p>
        <p :class="txn.credit_debit" class="mt-right">{{txn.credit_debit}}</p>
        <p class="mt-grey-text">{{txn.status}}</p>
      </div>
    </div>

    <table-loader v-if="!paginate.data_added || !paginate.stop" />

    <div class="table-empty" v-else-if="list.length === 0">
      <p>{{emptyRecords}}</p>
    </div>
  </div>
</template>

<script>
import UpiFilter from '@/components/UPIs/UpiStatementFilter'
import UpiExport from '@/components/global/ExportConfirmation'
import UpiDetails from '@/components/AccountStatement/StatementDetails'
import UpiWebhooks from '@/components/global/BulkResendWebhooks'

import ApiServices from '@/services/api/upi'
import listMixins from '@/mixins/listMixins'
import { amountFormat } from '@/utils/helpers'
import { mapMutations } from 'vuex'

export default {
  name: 'UPITransactions',
  components: { UpiFilter, UpiExport, UpiDetails, UpiWebhooks },
  mixins: [listMixins],
  created () {
    this.startProcessing()
  },
  methods: {
    amountFormat,
    ...mapMutations(['SET_UNPRIVILEGE_PAGE']),
    populateParams () {
      this.api['bulkResendWebhook'] = ApiServices.bulkResendWebhook
      this.api['export'] = ApiServices.exportTxns
      this.keys['list'] = 'transactions'
      this.keys['popup'] = 'UpiTxnDetails'
      const id = this.$route.params.id
      this.params['exportPath'] = id
      this.params['bulkWebhooks'] = id
      this.paginate['token_type'] = 'next_page_token'
    },
    fetchRecords (start) {
      return new Promise(resolve => {
        let params = {
          ...this.filterOptions
        }
        if (start) {
          params['next_page_token'] = this.paginate['next_page_token']
        }

        ApiServices.upiDetails(this.$route.params.id, params).then((response) => {
          this.SET_STATEMENT_FILTER(this.filterOptions)
          let data = response.data
          if (data) {
            const txnPrivileges = response.privileges.received_upi_txns
            if (!txnPrivileges) {
              this.SET_UNPRIVILEGE_PAGE(' ')
            }

            if (start) {
              if (txnPrivileges) {
                this.list.push(...data.transactions)
                if (data.next_page_token) {
                  this.paginate['next_page_token'] = data['next_page_token']
                } else {
                  this.paginate['stop'] = true
                }
                resolve()
              }
            } else {
              this.SET_SECTION_DETAILS({
                privileges: response.privileges,
                upi: data.upi
              })

              if (txnPrivileges) {
                this.list = data.transactions || []
                this.webhooksAllowed = data.webhook_allowed
                this.setPaginate(data)
                resolve()
              }
            }
          }
        }).catch((error) => {
          if (error.status === 404) {
            this.$router.push({name: 'UPIList'})
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/table.scss';

  .table-row {
    cursor: pointer;
  }

  .upi-details {
    margin-bottom: 15px;
  }
</style>
